import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

import { makeStyles, Input, Tooltip } from '@material-ui/core'

import StyledSVG from '../shared/StyledSVG'

import mediationAvatarSVG from '../../assets/icons/message-mediation.svg'
import searchIcon from '../../assets/icons/search-icon.svg'

const useStyles = makeStyles(theme => ({
  infiniteScrollWrapper: {
    height: '60vh',
    overflowY: 'auto'
  },
  room_participants_selected: {
    backgroundColor: '#E9FAD9 !important'
  },
  message_section: {
    cursor: 'pointer',
    display: 'flex',
    gap: 8,
    padding: '8px 8px',
    borderRadius: 8
  },
  room_participants: {
    borderRadius: 8,
    backgroundColor: '#F5F6F7',
    padding: 8
  },
  message_preview: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    overflowX: 'auto'
  },
  message_preview_info: {
    display: 'flex',
    flexDirection: 'column',
    '& h1': {
      color: '#555555',
      fontWeight: 500,
      fontSize: 14,
      margin: 0
    },
    '& span.description': {
      color: '#9F9F9F',
      fontWeight: 400,
      fontSize: 12,
      margin: 0
    }
  },
  chat_name: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  pending_view: {
    width: 16,
    height: 16,
    borderRadius: '100%',
    border: '1px solid #F69E9E',
    color: '#F69E9E',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12
  },
  search_component: {
    width: '100%',
    marginTop: '8px',
    marginBottom: '12px',
    padding: '8px 12px',
    borderRadius: 8,
    border: '1px solid #D2D5D8',
    '& input': {
      padding: 0
    }
  },
  infiniteScroll: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    overFlowX: 'hidden'
  }
}))

const MediationRoomMenuMessages = props => {
  const {
    clearMediationRooms,
    getChats,
    mediationRooms,
    handleClickRoom,
    currentUser,
    match
  } = props
  const classes = useStyles()
  const [inputValue, setInputValue] = React.useState('')

  const truncate = (text, limit) => {
    return text?.length > limit ? `${text.slice(0, limit)}...` : text
  }

  const handleSearchRoom = () => {
    clearMediationRooms()
    getChats({
      page: 1,
      params: {
        'q[name_cont]': inputValue
      }
    })
  }

  React.useEffect(() => {
    return () => {
      clearMediationRooms()
    }
  }, [])

  return (
    <div>
      <Input
        disableUnderline
        className={classes.search_component}
        placeholder='Busque pelo nome da intervenção'
        onChange={event => setInputValue(event.target.value)}
        onKeyDown={event => {
          handleSearchRoom()
        }}
        value={inputValue}
        startAdornment={
          <StyledSVG
            style={{ marginRight: 4 }}
            src={searchIcon}
            width={18}
            height={18}
          />
        }
      />
      <div id={'sidebarScrollable'} className={classes.infiniteScrollWrapper}>
        <InfiniteScroll
          dataLength={mediationRooms.items.length}
          next={() => {
            if (!mediationRooms.isFetching) {
              getChats({
                page: mediationRooms?.pagination?.page + 1,
                params: {
                  ...(inputValue.length > 0
                    ? {
                        'q[name_cont]': inputValue
                      }
                    : {})
                }
              })
            }
          }}
          className={classes.infiniteScroll}
          hasMore={
            mediationRooms.isFetching
              ? true
              : mediationRooms.pagination.total > mediationRooms.items.length &&
                mediationRooms.items.length !== 0
          }
          loader={<h4>Carregando...</h4>}
          endMessage={
            <p style={{ textAlign: 'center' }}>
              <b>Todas as intervenções carregadas.</b>
            </p>
          }
        >
          {mediationRooms.items?.length > 0 &&
            mediationRooms.items.map((item, index) => {
              const tooltipMessage = item?.last_message
                ? `Última mensagem: ${item?.last_message_author} - ${
                    item.last_message.content?.length > 0
                      ? truncate(item.last_message.content, 500)
                      : 'Mensagem sem conteúdo textual'
                  }`
                : ''
              const roomName =
                item.name ||
                `${item.room_participants
                  ?.filter(
                    rp =>
                      +rp.user.fractal_id !== +currentUser.attributes.fractal_id
                  )
                  .map(rp => rp.user.name)
                  .join(' + ')}`
              return (
                <Tooltip
                  key={`${item.id}${index}`}
                  title={tooltipMessage}
                  leaveDelay={50}
                  placement='right'
                  disableFocusListener
                  disableInteractive
                >
                  <div
                    onClick={() => handleClickRoom(item.id)}
                    key={`${item.id} ${Math.random()}`}
                    className={`${classes.message_section} ${
                      classes.room_participants
                    } ${
                      +match?.params?.chatId === +item.id
                        ? classes.room_participants_selected
                        : ''
                    }`}
                  >
                    <StyledSVG
                      src={mediationAvatarSVG}
                      width={40}
                      height={40}
                    />
                    <div className={classes.message_preview}>
                      <div className={classes.message_preview_info}>
                        <div className={classes.chat_name}>
                          <h1>{roomName}</h1>
                          {item?.pending_messages_count > 0 && (
                            <div className={classes.pending_view}>
                              {item?.pending_messages_count}
                            </div>
                          )}
                        </div>
                        <span className='description'>Intervenção</span>
                      </div>
                    </div>
                  </div>
                </Tooltip>
              )
            })}
        </InfiniteScroll>
      </div>
    </div>
  )
}

export default MediationRoomMenuMessages
